
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/special/clinical-reasoning",
      function () {
        return require("private-next-pages/special/clinical-reasoning/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/special/clinical-reasoning"])
      });
    }
  